import { useState } from 'react'

import { shipmentStatuses, useFetch } from '@reveni-io/reveni-ui'

import { isTrackingParcel } from '@/parcels/helpers/helpers'
import parcelServices from '@/parcels/services/services'

import { getEditDestinationAddressPayload } from './helpers'

const useParcelOutboundDestinationAddress = ({
  storeId,
  parcelId,
  refetchParcel,
  setToastInfo,
  requiresCustomerTaxId,
  parcel,
  isPickupPoint,
}) => {
  const { fetchData, loading } = useFetch(parcelServices.editParcel, { doInitialRequest: false })
  const [showEditOutboundDestinationAddressModal, setShowEditOutboundDestinationAddressModal] = useState(false)

  const openEditOutboundDestinationAddressModal = () => {
    setShowEditOutboundDestinationAddressModal(true)
  }

  const closeEditOutboundDestinationAddressModal = () => {
    setShowEditOutboundDestinationAddressModal(false)
  }

  const onEditOutboundDestinationAddress = async address => {
    const payload = getEditDestinationAddressPayload(address, requiresCustomerTaxId)

    try {
      await fetchData({ storeId, parcelId, payload })
      closeEditOutboundDestinationAddressModal()
      refetchParcel()
    } catch (error) {
      setToastInfo({ show: true, type: 'error', message: error.errorMessage })
    }
  }

  const allowEditOutboundDestinationAddress =
    !isTrackingParcel(parcel) &&
    [shipmentStatuses.requested, shipmentStatuses.packed, shipmentStatuses.ready].includes(parcel?.status) &&
    !isPickupPoint

  return {
    showEditOutboundDestinationAddressModal,
    openEditOutboundDestinationAddressModal,
    closeEditOutboundDestinationAddressModal,
    onEditOutboundDestinationAddress,
    editingAddress: loading,
    allowEditOutboundDestinationAddress,
  }
}

export default useParcelOutboundDestinationAddress
